import { Col, Row } from "react-bootstrap";
import LicenceProfileHeader from "../LicenceProfileHeader";
import LicenceProfileSubTabs from "../LicenceProfileSubTabs";
import BreadCrumbs from "./BreadCrumbs";
import { useParams } from "react-router-dom";
import Page404 from "../../../pages/auth/Page404";
import useAppSelector from "../../../hooks/useAppSelector";
import {
  loadLicenceProfileAsync,
  selectLicenceProfileResponse,
} from "../../../redux/slices/licenceProfile";
import useAppDispatch from "../../../hooks/useAppDispatch";
import Loading from "../../../leap-components/Loading";
import BackToCompliance from "../ComplianceTab/BackToCompliance";
import { useState } from "react";
import {
  GetLicenceProfileNotReadyComponent,
  IsLicenceProfileReady,
} from "../../../leap-components/LicenceProfile/LicenceProfileResponseComponentFactory";
import { ILicenceProfile } from "../../../api/ILicenceProfile";
import MeetingHeader from "./MeetingHeader";
import MeetingDetails from "./MeetingDetails";
import { loadMeetingAsync, selectMeeting } from "../../../redux/slices/meeting";
import RelatedComplianceRecords from "./RelatedComplianceRecords";
import Page500 from "../../../pages/auth/Page500";

const Meeting = () => {
  const [loading, setLoading] = useState(false);
  const [loadingMeetingId, setLoadingMeetingId] = useState("");
  const licenceProfileSelector = useAppSelector(selectLicenceProfileResponse);
  const meetingSelector = useAppSelector(selectMeeting);

  const dispatch = useAppDispatch();

  let { profileNo, meetingId } = useParams();
  if (!profileNo || !meetingId) {
    return <Page404 />;
  }

  if (!loading) {
    setLoading(true);
    dispatch(loadLicenceProfileAsync(profileNo));
    return <Loading />;
  }

  if (!IsLicenceProfileReady(licenceProfileSelector.licenceProfileResponse)) {
    return GetLicenceProfileNotReadyComponent(
      licenceProfileSelector.licenceProfileResponse
    );
  }

  const licenceProfile = licenceProfileSelector.licenceProfileResponse
    ?.licenceProfile as ILicenceProfile;

  if (loadingMeetingId !== meetingId) {
    setLoadingMeetingId(meetingId);
    dispatch(loadMeetingAsync(meetingId));
    return <Loading />;
  }

  const meetingDetails = meetingSelector.meeting;

  if (!meetingDetails) {
    return <Loading />;
  }

  if (!meetingDetails.response.ok) {
    if (meetingDetails.response.status === 404) {
      return <Page404 />;
    } else {
      return <Page500 />;
    }
  }

  const contentElement = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <MeetingHeader
            licenceProfile={licenceProfile}
            meetingDetails={meetingDetails}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <MeetingDetails meetingDetails={meetingDetails} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <RelatedComplianceRecords meeting={meetingDetails} />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs
        licenceProfile={licenceProfile}
        meetingDetails={meetingDetails}
      />
      <div className="ps-0">
        <LicenceProfileHeader licenceProfile={licenceProfile} />
        <LicenceProfileSubTabs
          activeKey="compliance-records"
          content={contentElement}
          licenceProfile={licenceProfile}
        />
      </div>
    </div>
  );
};

export default Meeting;
